var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_270:129983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 3.6531C35.6145 4.26268 34.1449 4.66281 32.6401 4.84018C34.2075 3.90717 35.411 2.4297 35.9777 0.669321C34.4877 1.54748 32.8575 2.1662 31.1575 2.49875C29.7727 1.03363 27.8 0.117981 25.6166 0.117981C21.4243 0.117981 18.0254 3.49348 18.0254 7.65674C18.0254 8.24769 18.0926 8.82301 18.2219 9.37492C11.9131 9.06042 6.31977 6.05913 2.57569 1.49798C1.92241 2.61143 1.54807 3.90659 1.54807 5.28803C1.54807 7.90363 2.88831 10.211 4.92505 11.5631C3.71958 11.5256 2.54064 11.2022 1.48665 10.62C1.48621 10.6516 1.48621 10.6832 1.48621 10.7149C1.48621 14.3676 4.10281 17.4146 7.57532 18.1072C6.45749 18.4091 5.28497 18.4533 4.14732 18.2364C5.11323 21.2315 7.9167 23.411 11.2383 23.472C8.64037 25.494 5.36717 26.6993 1.81083 26.6993C1.19802 26.6993 0.593879 26.6635 0 26.5939C3.35934 28.733 7.34941 29.981 11.6362 29.981C25.5989 29.981 33.2341 18.4933 33.2341 8.53104C33.2341 8.20406 33.2269 7.87894 33.2121 7.55569C34.6982 6.48873 35.9809 5.16719 37 3.6531Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_270:129983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.46f29ae3.svg";
export { ForwardRef as ReactComponent };